<template lang="pug">
  div
    ValidationProvider(:rules="rules" v-slot="{ errors }")
      v-text-field(
        v-model="valuefield"
        :disabled="disabled"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        @click:append="showPassword = !showPassword"
        :error="errors.length > 0"
        @input="inputFill()")
        template(v-slot:label)
          v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
          | {{ label }}
      span.red--text.text--accent-2(v-if="errors.length > 0")
        v-icon(color="red accent-2") mdi-alert
        |  {{ errors[0] }}
      span.red--text.text--accent-2(v-else-if="!confirmMatch")
        v-icon(color="red accent-2") mdi-alert
        |  {{ translations.repeatpassword }}
    v-progress-linear.mb-4(v-if="showProgress" :value="valueConditions" rounded :color="getColor")
</template>

<script>
  export default {
    name: "BasePasswordField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      confirm: {
        type: String,
        default: null
      },
      showProgress: {
        type: Boolean,
        default: false
      },
    },
    data:() => ({
      valuefield: '',
      showPassword: false,
      progress: {
        value: 30,

      },
    }),
    computed: {
      translations() {
        return this.$t("components.basePasswordField");
      },
      isRequired(){
        return this.rules.includes('required');
      },
      confirmMatch(){
        if (this.confirm != null && this.valuefield != ''){
          return this.valuefield == this.confirm;
        } else {
          return true;
        }
      },
      getColor(){
        let color;
        if(this.valueConditions == 100){
          color = 'green lighten-1';
        } else if(this.valueConditions < 100 && this.valueConditions >= 66){
          color = 'lime lighten-1';
        } else if (this.valueConditions < 66 && this.valueConditions >= 33){
          color = 'orange lighten-1';
        } else if (this.valueConditions < 33 && this.valueConditions >= 1){
          color = 'red lighten-2';
        } else {
          color = 'white';
        }
        return color;
      },
      valueConditions(){
        let progress = 0;
        if(this.value.length >= 6){
          progress += 20;
        }
        if(/[A-ZÑ]/.test(this.value)){
          progress += 20;
        }
        if(/[a-zñ]/.test(this.value)){
          progress += 20;
        }
        if(/\d/.test(this.value)){
          progress += 20;
        }
        // eslint-disable-next-line no-useless-escape
        if(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.value)){
          progress += 20;
        }
        return progress
      }
    },
    watch: {
      value: function(val){
        this.valuefield = val;
      }
    },
    created(){
      this.valuefield = this.value;
    },
    methods:{
      inputFill(){
        this.$emit('input', this.valuefield);
      },
    },
  }
</script>

<style lang="sass">
</style>